import { UpdateControlMetadata } from '../validators/helpers';

export function FxFlex(fxFlex: string) {
  return function (target: any, propertyKey: string) {
    UpdateControlMetadata(target, propertyKey, { fxFlex });
  }
}
